import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
  standalone: false
})
export class PortalComponent { }
